import type { ReactNode } from 'react'
import { cx } from './utils/cx'

// 'waiting' | 'ready' | 'expired' | 'hot' are from the reference library.
// 'pending' | 'received' | 'warn' | 'locked' | 'revoked' are SnapTransfer
// extensions added so the transfer/activity flows can map their status
// vocabulary 1:1 without the caller losing information. CSS lives in
// components.css extension section.
export type StatusVariant =
  | 'waiting'
  | 'ready'
  | 'expired'
  | 'hot'
  | 'pending'
  | 'received'
  | 'warn'
  | 'locked'
  | 'revoked'

export function StatusChip({
  variant = 'waiting',
  children,
  withLed = true,
  className
}: {
  variant?: StatusVariant
  children?: ReactNode
  withLed?: boolean
  className?: string
}) {
  return (
    <span className={cx('st-status', variant, className)}>
      {withLed && <span className="led" />}
      {children || variant}
    </span>
  )
}
